import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M0 4a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#0079BE",
  "fill-rule": "evenodd",
  d: "M15.839 19.3h2.596c4.052 0 7.281-3.215 7.408-7.187v-.062c-.063-4.035-3.356-7.313-7.408-7.25h-2.913c-3.863.126-6.902 3.404-6.775 7.313 0 3.908 3.166 7.123 7.092 7.186m-5.826-7.25c0-3.278 2.723-5.988 6.015-5.988 3.293 0 6.016 2.71 6.016 5.988s-2.723 5.99-6.016 5.99c-3.292 0-6.015-2.711-6.015-5.99m6.965 4.035V8.079c2.216.567 3.61 2.774 3.04 4.98a4.11 4.11 0 0 1-3.04 3.026m-4.875-5.043a4.14 4.14 0 0 0 2.976 5.043V8.079a4.16 4.16 0 0 0-2.976 2.963",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#E8E8ED",
  d: "M4 1h26v-2H4zm29 3v16h2V4zm-3 19H4v2h26zM1 20V4h-2v16zm3 3a3 3 0 0 1-3-3h-2a5 5 0 0 0 5 5zm29-3a3 3 0 0 1-3 3v2a5 5 0 0 0 5-5zM30 1a3 3 0 0 1 3 3h2a5 5 0 0 0-5-5zM4-1a5 5 0 0 0-5 5h2a3 3 0 0 1 3-3z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }